import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { HttpResolverService } from './resolvers/http/http-resolver.service';

/*
 * Unprotected pages: all defined in this app.routes.ts file
 * Protected pages: all defined in the split-pane-routes.ts file
 */

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'login',
    loadComponent: () => import('./public/login/login.page').then((m) => m.LoginNewPage),
  },
  //registration flow
  {
    path: 'create-account',
    loadComponent: () =>
      import('./public/registration/create-account/create-account.page').then(
        (m) => m.CreateAccountPage,
      ),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'create-password',
    loadComponent: () =>
      import('./public/registration/create-password/create-password.page').then(
        (m) => m.CreatePasswordPage,
      ),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'last-4-digit-ssn',
    loadComponent: () =>
      import('./public/registration/last-4-digit-snn/last-4-digit-snn.page').then(
        (m) => m.Last4DigitSnnPage,
      ),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'account-already-exist',
    loadComponent: () =>
      import('./public/registration/account-already-exist/account-already-exist.page').then(
        (m) => m.AccountAlreadyExistPage,
      ),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'about-you',
    loadComponent: () =>
      import('./public/registration/about-you/about-you.page').then((m) => m.AboutYouPage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'registration/assisted-registration',
    loadComponent: () =>
      import('.//public/registration/assisted-registration/assisted-registration.page').then(
        (m) => m.AssistedRegistrationPage,
      ),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'email-verification',
    loadComponent: () =>
      import('./public/registration/email-verification/email-verification.page').then(
        (m) => m.EmailVerificationPage,
      ),
  },
  {
    path: 'oauth-email-verification',
    loadComponent: () =>
      import('./public/login/oauth-email-verification/oauth-email-verification.page').then(
        (m) => m.OauthEmailVerificationPage,
      ),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'oauth-pending-registration-expired',
    loadComponent: () =>
      import(
        './public/login/oauth-pending-registration-expired/oauth-pending-registration-expired.page'
      ).then((m) => m.OauthPendingRegistrationExpiredPage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'portal/dispatcher/sign-in',
    redirectTo: 'login', // Redirects to the 'login' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'portal/dispatcher/my-account',
    redirectTo: 'login', // Redirects to the 'overview' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/split-pane/split-pane-routes').then((m) => m.routes),
    title: 'COUNTRY Financial - My Account',
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'authorized-user',
    loadChildren: () =>
      import('./public/authorized-user/authorized-user-routes').then((m) => m.routes),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'account-conversion',
    loadChildren: () =>
      import('./pages/account-conversion/account-conversion-routes').then((m) => m.routes),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'offline-id-card-detail',
    loadComponent: () =>
      import('./public/offline-id-card-detail/offline-id-card-detail.page').then(
        (m) => m.OfflineIdCardDetailPage,
      ),
  },
  // Adding portal/dispatcher/my-preferences path since email links in Paperless emails to point to this Url.
  // Once post MVP confirm in Azure logs no more requests coming to this page then remove this routing.
  {
    path: 'portal/dispatcher/my-preferences',
    redirectTo: 'app/communication-preferences', // Redirects to the 'communication-preferences' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'portal/dispatcher/forgot-password',
    redirectTo: 'login', // Redirects to the 'login' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'portal/dispatcher/registration-pbr-person',
    redirectTo: 'login', // Redirects to the 'registration' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'registration/personal-registration',
    redirectTo: 'login', // Redirects to the 'registration' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'registration',
    redirectTo: 'login', // Redirects to the 'registration' page
    pathMatch: 'full', // Make sure it only matches the full path
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'planningtool-router',
    loadComponent: () =>
      import('./public/emoney-invite/emoney-invite.page').then((m) => m.EmoneyInvitePage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    // https://myqa.countryfinancial.net/portal/dispatcher/planningtool-router?inviteID=7f069db9-4415-4d1c-b50f-b91df6589751-PRI
    path: 'portal/dispatcher/planningtool-router',
    loadComponent: () =>
      import('./public/emoney-invite/emoney-invite.page').then((m) => m.EmoneyInvitePage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  // PAS Paperless email link to policy document, old link
  {
    path: 'portal/dispatcher/stream-data/display-document',
    loadComponent: () =>
      import('./public/stream-data/stream-data.page').then((m) => m.StreamDataPage),
    canActivate: [AuthGuard],
    resolve: {
      initialData: HttpResolverService,
    },
  },
  // PAS Paperless email link to auto id card, old link
  {
    path: 'portal/dispatcher/stream-data/display-autoidcard',
    loadComponent: () =>
      import('./public/stream-idcard/stream-idcard.page').then((m) => m.StreamIdcardPage),
    canActivate: [AuthGuard],
    resolve: {
      initialData: HttpResolverService,
    },
  },
  // Billing paperless email with link to billing summary
  {
    path: 'portal/dispatcher/my-bill/:accountNumber',
    redirectTo: 'app/billing-summary',
    pathMatch: 'full',
    resolve: {
      initialData: HttpResolverService,
    },
  },
  // PAS Paperless email link to auto id card
  {
    path: 'stream-data/display-autoidcard',
    loadComponent: () =>
      import('./public/stream-idcard/stream-idcard.page').then((m) => m.StreamIdcardPage),
    canActivate: [AuthGuard],
    resolve: {
      initialData: HttpResolverService,
    },
  },
  // PAS Paperless email link to policy document
  {
    path: 'stream-data/display-document',
    loadComponent: () =>
      import('./public/stream-data/stream-data.page').then((m) => m.StreamDataPage),
    canActivate: [AuthGuard],
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'kubrassoreturn',
    loadComponent: () =>
      import('./public/kubra-sso-return/kubra-sso-return.page').then((m) => m.KubraSsoReturnPage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'oauth-email-verification-success',
    loadComponent: () =>
      import(
        './public/login/oauth-email-verification-success/oauth-email-verification-success.page'
      ).then((m) => m.OauthEmailVerificationSuccessPage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'error',
    loadComponent: () => import('./public/error-page/error-page.page').then((m) => m.ErrorPagePage),
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'portal/dispatcher/contact-us',
    loadComponent: () =>
      import('./public/contact-us-redirect/contact-us-redirect.component').then(
        (m) => m.ContactUsRedirectComponent,
      ),
  },
  {
    path: 'ssotransfer',
    loadComponent: () =>
      import('./pages/ssotransfer/ssotransfer.page').then((m) => m.SsotransferPage),
  },
  {
    path: 'display-stream',
    loadComponent: () =>
      import('./pages/display-stream/display-stream.page').then((m) => m.DisplayStreamPage),
  },
  {
    path: 'glass-claim-sso-transfer',
    loadComponent: () =>
      import('./pages/glass-claim-sso-transfer/glass-claim-sso-transfer.page').then(
        (m) => m.GlassClaimSsoTransferPage,
      ),
  },

  //paperless-onboarding
  {
    path: 'paperless-onboarding',
    loadChildren: () =>
      import('./public/paperless-onboarding/paperless-onboarding-routes').then((m) => m.routes),
    canActivate: [AuthGuard],
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'portal/dispatcher/my-bill',
    loadComponent: () => import('./public/my-bill/my-bill.page').then((m) => m.MyBillPage),
    canActivate: [AuthGuard],
    resolve: {
      initialData: HttpResolverService,
    },
  },
  {
    path: 'paperless-onboarding/success',
    loadComponent: () =>
      import('./public/paperless-onboarding/success/success.page').then((m) => m.SuccessPage),
  },
  {
    path: 'paperless-onboarding/error',
    loadComponent: () =>
      import('./public/paperless-onboarding/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path: 'pbr-account-blocked',
    loadComponent: () =>
      import('./public/login/pbr-account-blocked/pbr-account-blocked.page').then(
        (m) => m.PbrAccountBlockedPage,
      ),
  },
  {
    path: 'callback',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'callback/logout',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '404',
    redirectTo: '/error',
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
